import { render, staticRenderFns } from "./BaseYxPay.vue?vue&type=template&id=2f93082c&scoped=true"
import script from "./BaseYxPay.vue?vue&type=script&lang=js"
export * from "./BaseYxPay.vue?vue&type=script&lang=js"
import style0 from "./BaseYxPay.vue?vue&type=style&index=0&id=2f93082c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93082c",
  null
  
)

export default component.exports